import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

/**
 * Pipe utilizado para gerar o nome de arquivos com a data de geração.
 */
@Pipe({ name: "fileNameGenerator" })
export class FileNameGeneratorPipe implements PipeTransform {

    transform(fileNamePrefix: string, extension: string): string {
        const df = moment(new Date()).format("YYYYMMDDHHmmss");
        return fileNamePrefix + df + extension;
    }
}
